import React, { useState } from 'react';
import {
    Card, CardHeader, CardBody, CardFooter, Button, Modal,
    ModalHeader,
    ModalBody,
} from 'reactstrap';
import { SelectPicker } from 'rsuite';


// function tog_scroll() {
//     setmodal_addProducts(!modal_addProducts);
//     // removeBodyCss();
// }
const CartPreview = ({
    cartItemClone,
    countryInfo,
    serviceOptions,
    selectedService,
    customPrices,
    setShowShippingControll,
    setShowmapandAddress,
    disableNextToAddress,
    customPriceCheckboxChange,
    ChangeCustomPrice,
    ChangeCustomQty,
    removeItem,
    updateCustomPrice,
    handleSelectServiceType
}) => {

    return (
        <>
            {cartItemClone?.length > 0 ? (
                <Card>
                    <CardHeader>
                        <h6>Customer Basket</h6>
                    </CardHeader>
                    <CardBody className="p-0">
                        <div className="border-0">
                            <table className="table table-hover mb-0 align-middle">
                                <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col"></th>
                                        <th scope="col">Product</th>
                                        <th scope="col">Price </th>
                                        <th scope="col">Custom Price</th>
                                        <th scope="col">QTY</th>
                                        <th scope="col">Discount</th>
                                        <th scope="col">Total</th>
                                        <th scope="col">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {cartItemClone?.map((item, index) => {
                                        if (item?.product?.coreFields?.itemMode === 2) {
                                            setShowShippingControll(false);
                                        }
                                        return (
                                            <React.Fragment key={index}>
                                                <tr>
                                                    <th scope="row">{index + 1}</th>
                                                    <td>
                                                        <img
                                                            alt=""
                                                            width="76"
                                                            height="76"
                                                            className="img-thumbnail"
                                                            src={item?.product?.mediaGallery?.[0]?.value}
                                                        />
                                                    </td>
                                                    <td className="product">
                                                        <p
                                                            className="m-0 fw-medium"
                                                            style={{ maxWidth: 500 }}
                                                        >
                                                            {item.product.name}{' '}
                                                            {selectedService ? ` - ${selectedService}` : null}
                                                        </p>
                                                        <p className="m-0 text-muted fs-11">
                                                            SKU : {item.sku}
                                                        </p>
                                                        {item?.product?.customizedOptions?.isCustomized && (
                                                            <p className="m-0 text-muted fs-11 fw-medium">
                                                                {item.product.customizedOptions.customizedCategory} :
                                                                <span className='text-black'>{item.product.customizedOptions.area}㎡ (Length: {item.product.customizedOptions.length}cm, Width: {item.product.customizedOptions.width} cm)</span >
                                                            </p>
                                                        )}
                                                        {item?.product?.customizedOptions?.customizedCategory === 'mattress' ? (
                                                            <>
                                                                <p className="m-0 fw-bold mt-2 text-danger">
                                                                    Customized Product. It cannot be canceled, exchanged or returned.
                                                                </p>
                                                                <p className="m-0">
                                                                    <i>Note: Products can be cancelled only in case of any manufacturing defect. Once ordered, they can’t be cancelled, returned, or exchanged.</i>
                                                                </p>
                                                            </>
                                                        ) : ('')}
                                                        {item?.sku === '990700100004' ? (
                                                            <p>
                                                                Service Name :{' '}
                                                                <SelectPicker
                                                                    data={serviceOptions}
                                                                    placeholder="Select a Service Type"
                                                                    onChange={handleSelectServiceType}
                                                                    required
                                                                />
                                                            </p>
                                                        ) : null}


                                                        {item?.product?.coreFields?.itemMode === 2 && (
                                                            <p>
                                                                Item Type :
                                                                <span className="ps-2 text-danger fw-bold pe-3">
                                                                    Back to Back
                                                                </span>{' '}
                                                                Supplier name :{' '}
                                                                <span className="ps-2 text-danger fw-bold">
                                                                    {item?.product?.coreFields?.supplierInfo?.code.replace(
                                                                        /-/g,
                                                                        ' '
                                                                    )}
                                                                </span>
                                                            </p>
                                                        )}
                                                    </td>
                                                    <td className="addCustomPrice">
                                                        <div className="d-flex align-items-center justify-content-start gap-1">
                                                            {countryInfo?.currency}{' '}
                                                            {item?.product?.defaultPrice?.specialPrice.toFixed(2) !==
                                                                parseFloat(item?.product?.selectedPrice?.specialPrice).toFixed(2) ? (
                                                                <p className="text-nowrap m-0 fw-medium">
                                                                    <span className="CrossText text-danger">
                                                                        {parseFloat(item?.product?.defaultPrice?.specialPrice).toFixed(2)}
                                                                    </span>
                                                                </p>
                                                            ) : null}
                                                            <p className="text-nowrap m-0 fw-medium">
                                                                {isNaN(parseFloat(item?.product?.selectedPrice?.specialPrice))
                                                                    ? '0.00'
                                                                    : parseFloat(item?.product?.selectedPrice?.specialPrice).toFixed(2)}
                                                            </p>
                                                        </div>
                                                        {!item?.product?.customizedOptions?.isCustomized && (<div className="form-check">
                                                            <input
                                                                className="form-check-input"
                                                                name="customPriceEnable[]"
                                                                type="checkbox"
                                                                onChange={(e) =>
                                                                    customPriceCheckboxChange(e, item._id, index)
                                                                }
                                                                checked={customPrices[item._id] !== undefined}
                                                                id={'check_custom_' + item._id}
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor={'check_custom_' + item._id}
                                                            >
                                                                Custom Price
                                                            </label>
                                                        </div>)}
                                                    </td>
                                                    <td>
                                                        {item?.product?.coreFields?.itemMode !== 2 && (
                                                            <input
                                                                name="customPrice"
                                                                required
                                                                id={'price_custom_' + item?._id}
                                                                type="text"
                                                                value={item?.product?.selectedPrice?.specialPrice}
                                                                className={`${!customPrices[item?._id] &&
                                                                    customPrices[item?._id] !== ''
                                                                    ? 'customPriceTxtClr'
                                                                    : 'customPriceTxtClrInvert'
                                                                    } form-control customPrice`}
                                                                disabled={
                                                                    !customPrices[item?._id] &&
                                                                    customPrices[item?._id] !== ''
                                                                }
                                                                onChange={(e) => ChangeCustomPrice(e, index)}
                                                                style={{ maxWidth: 120 }}
                                                            />
                                                        )}
                                                    </td>
                                                    <td>
                                                        {!item?.product?.customizedOptions?.isCustomized ? (<input
                                                            name={`qty-${item?.sku}`}
                                                            required
                                                            id={`qty-${item?.sku}`}
                                                            type="text"
                                                            className="form-control qty"
                                                            value={item.qty}
                                                            onChange={(e) => ChangeCustomQty(e, index)}
                                                            style={{ maxWidth: 70 }}
                                                        />) : (
                                                            <>
                                                                {item.qty} {`(${item.product.customizedOptions.area}) ㎡`}
                                                            </>
                                                        )}
                                                    </td>
                                                    <td>0.00</td>
                                                    <td>
                                                        <p className="text-nowrap mb-0 fw-medium">
                                                            {countryInfo?.currency}{' '}
                                                            {item?.product?.cart?.subTotal?.toFixed(2)}
                                                        </p>
                                                    </td>
                                                    <td>
                                                        <div className="d-flex justify-content-end gap-2">
                                                            <Button
                                                                color="danger"
                                                                outline
                                                                onClick={() => removeItem(item?._id)}
                                                                className="fs-11 px-2 py-1"
                                                            >
                                                                Delete
                                                            </Button>{' '}
                                                            <Button
                                                                color="success"
                                                                type="button"
                                                                onClick={() => updateCustomPrice(index)}
                                                                className="fs-11 px-2 py-1"
                                                            >
                                                                Update
                                                            </Button>
                                                        </div>
                                                    </td>
                                                </tr>
                                                {/* Render options row if item.options is not null and is an array with length */}
                                                {Array.isArray(item.options) && item.options.length > 0 && (
                                                    item.options.map((opt, optIdx) => (
                                                        <tr className="bg-light align-middle" key={optIdx}>
                                                            <td></td>
                                                            <td>
                                                                <img
                                                                    src="https://s3.me-central-1.amazonaws.com/assets.danubehome.com/media/colors/Group_178575.svg"
                                                                    alt="Option Icon"
                                                                    width={76}
                                                                    height={76}
                                                                    style={{ marginRight: 8 }}
                                                                />
                                                            </td>
                                                            <td colSpan="2"><strong>{opt.name} - {opt.sku}</strong><p>{opt.description}</p>
                                                                <p className='mb-0'>{opt.currency.toUpperCase()} {opt.price}{'/'}{opt.uom}</p>
                                                            </td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td className='m-0 fw-medium'> {opt.currency.toUpperCase()} {' '} {opt.grandTotal.toFixed(2)}</td>
                                                            <td></td>
                                                            <td></td>
                                                        </tr>
                                                    ))
                                                )}
                                            </React.Fragment>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </CardBody>
                    <CardFooter>
                        {Object.keys(cartItemClone).length > 0 && (
                            <div className="d-flex justify-content-end">
                                <Button
                                    type="submit"
                                    color="dark"
                                    className="fs-12"
                                    onClick={() => {
                                        setShowmapandAddress(true);
                                    }}
                                    disabled={disableNextToAddress}
                                >
                                    Continue
                                </Button>
                            </div>
                        )}
                    </CardFooter>
                </Card >


            ) : (
                <p className="text-center">No items added</p>
            )
            }
        </>
    );
};
export default CartPreview;